import { OUTLINE_WRAPPER_SELECTOR_MAIN } from "../constants/selectors";
import selectSingleElement from "../dom/selectSingleElement";
import onRemove from "./onRemoveListener";

function appendRemoveForOutlineSwatches() {
  // First, clean up any existing remove buttons
  const existingRemoveBtn = document.querySelector(
    `${OUTLINE_WRAPPER_SELECTOR_MAIN} .remove-btn`,
  );
  if (existingRemoveBtn) {
    existingRemoveBtn.remove();
  }

  const outlineWrapper = selectSingleElement<HTMLDivElement>(
    OUTLINE_WRAPPER_SELECTOR_MAIN,
  );
  if (!outlineWrapper) {
    console.warn("Outline wrapper not found");
    return;
  }

  const remove = document.createElement("a");
  remove.href = "#";
  remove.classList.add("remove-btn");
  remove.dataset.price = "0";
  remove.dataset.value = "";
  remove.dataset.frame = "4";

  // Use addEventListener instead of onclick
  remove.addEventListener("click", (e) => {
    e.preventDefault();
    onRemove(e);
  });

  remove.innerText = " ";
  remove.ariaLabel = "Remove";

  const tooltip = document.createElement("div");
  tooltip.classList.add("swtooltip", "before");
  tooltip.innerText = "No Outline";
  tooltip.style.display = "none";
  tooltip.style.bottom = "100%";
  tooltip.style.top = "auto";
  tooltip.style.pointerEvents = "none";

  remove.appendChild(tooltip);
  outlineWrapper.appendChild(remove);
}

export default appendRemoveForOutlineSwatches;
